import {
  MYVOUCHERS_FAILED,
  MYVOUCHERS_SUCCESS,
  LOADING_MYVOUCHERS,
  RESET_MYVOUCHERS,
} from "../types";

const initialState = {
  isLoading: false,
  failed: false,
  success: false,
  data: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_MYVOUCHERS: {
      return {
        ...state,
        isLoading: true,
        failed: false,
        success: false,
        invalidRequest: false,
        data: {},
      };
    }
    case MYVOUCHERS_FAILED: {
      return {
        ...state,
        isLoading: true,
        failed: true,
        success: false,
        invalidRequest: false,
        data: {},
      };
    }
    case MYVOUCHERS_SUCCESS: {
      return {
        ...state,
        isLoading: true,
        failed: true,
        success: true,
        invalidRequest: false,
        data: action.payload,
      };
    }
    case RESET_MYVOUCHERS: {
      return (state = initialState);
    }
    default:
      return state;
  }
};
